module.exports = __webpack_public_path__ + "static/media/sensable_25.68915975.gif";